import { Button, ButtonProps } from "@chakra-ui/react";

export const PrimayButton: React.FC<ButtonProps> = ({
  children,
  ...othersProps
}) => (
  <Button colorScheme={"purple"} px="3rem" {...othersProps}>
    {children}
  </Button>
);
